import { RibbonSlot, Select } from "@tredespace/ui/widgets";
import type { JSX } from "react";
import type { DeckKind } from "../../engine/tools/types.ts";
import type { PlankFamily } from "../../model/types.ts";
import { setDeckKind, setPlankFam } from "../../state/tool/tool.actions.ts";
import type { ToolState } from "../../state/tool/tool.state.ts";

const DECK_KINDS: readonly { value: DeckKind; label: string }[] = [
  { value: "bay", label: "Whole bay" },
  { value: "board", label: "Single plank" },
];

const PLANK_FAMILIES: readonly { value: PlankFamily; label: string }[] = [
  { value: "mix", label: "ALP 230 + 170" },
  { value: "230", label: "ALP 230" },
  { value: "170", label: "ALP 170" },
];

function toDeckKind(value: string): DeckKind {
  return value === "board" ? "board" : "bay";
}

function toPlankFamily(value: string): PlankFamily {
  if (value === "230" || value === "170") {
    return value;
  }

  return "mix";
}

/**
 * Deck tool options: a whole bay in the chosen boards, or one board at a time.
 * Returned as a flat list because the ribbon section packs columns from its
 * direct children's `size`. The board width for single planks is the tool's
 * size select, rendered by the caller.
 */
export function deckOptionSlots({ deckKind, plankFam }: ToolState): JSX.Element[] {
  const slots = [
    <RibbonSlot key="kind" size="medium">
      <Select
        value={deckKind}
        onChange={(value) => value && setDeckKind(toDeckKind(value))}
        options={DECK_KINDS.map((entry) => ({ value: entry.value, label: entry.label }))}
      />
    </RibbonSlot>,
  ];

  if (deckKind === "bay") {
    slots.push(
      <RibbonSlot key="family" size="medium">
        <Select
          value={plankFam}
          onChange={(value) => value && setPlankFam(toPlankFamily(value))}
          options={PLANK_FAMILIES.map((entry) => ({ value: entry.value, label: entry.label }))}
        />
      </RibbonSlot>,
    );
  }

  return slots;
}
